import { server_connection } from 'config';

export const GET_NOTE        = '[NOTE] GET NOTE';
export const SAVE_NOTE       = '[NOTE] SAVE NOTE';
export const GET_NOTE_LIST   = '[NOTE] GET NOTE LIST';
export const UPDATE_NOTE     = '[NOTE] UPDATE NOTE';
export const CLEAR_NOTE      = '[NOTE] CLEAR NOTE';
export const SET_NOTE_LOADED = '[NOTE] SET NOTE AS LOADED';
export const DELETE_NOTE     = '[NOTE] DELETE NOTE';
export const VIEW_NOTE       = '[NOTE] VIEW NOTE';

export function getNoteList(table_name, table_id) {
    return (dispatch) => {
        fetch(server_connection + '/note/list/' + table_name + '/' + table_id)
            .then((response) => response.json())
            .then((noteList) => {
                dispatch({
                    type: GET_NOTE_LIST,
                    payload: { noteList, table_name, table_id },
                });
            });
    }
}

export function getNote(note_id) {
    return (dispatch) => {
        fetch(server_connection + '/note/get/' + note_id)
            .then((response) => response.json())
            .then((note) => {
                dispatch({
                    type: GET_NOTE,
                    payload: note
                })
            });
    }
}

export function setNoteLoaded(table_name, table_id) {
    return (dispatch) => {
        dispatch({
            type: SET_NOTE_LOADED,
            payload: { table_name, table_id }
        })
    }
}

export function clearNote() {
    return (dispatch) => {
        dispatch({
            type: CLEAR_NOTE
        });
    }
}

export function viewNote() {
    return (dispatch) => {
        dispatch({
            type: VIEW_NOTE
        })
    }
}

export function saveNote(note_id, note, table_name='', table_id='') {
    return (dispatch) => {
        fetch(server_connection + '/note/save',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ note_id: note_id, note: note })
            })
            .then((response) => {
                if(table_name !== '' && table_id !== '') {
                    dispatch(getNoteList(table_name, table_id));
                }
            });
    }
}

export function deleteNote(note_id) {
    return (dispatch) => {
        fetch(server_connection + '/note/delete',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ note_id: note_id })
            })
            .then((response) => {
                dispatch({
                    type: DELETE_NOTE,
                    payload: note_id
                })
            });
    }
}

export function updateNote(update_data) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_NOTE,
            payload: update_data
        });
    }
}


// WEBPACK FOOTER //
// src/main/components/note/store/actions/note.actions.js